import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import { MICROSERVICES } from '@shared/constants/microservices';
import { Observable } from 'rxjs';
import { UserProfileUpdate } from './interfaces/user-settings.interface';
import { UserSettingsRepository } from './user-settings.repository';

@Injectable({
    providedIn: 'root',
})
export class UserSettingsService implements UserSettingsRepository {
    private readonly http = inject(HttpClient);
    private readonly apiUrl = environment.url;

    updateUserProfile(profile: UserProfileUpdate): Observable<UserProfileUpdate> {
        return this.http.patch<UserProfileUpdate>(`${this.apiUrl}${MICROSERVICES.accounts}/user`, profile);
    }
}
